import type { Lang } from '../i18n';
import { translate } from '../i18n';

/** 将 ISO 时间字符串格式化为本地显示（24 小时制，随界面语言切换），无效或空值返回占位符 */
export function formatTime(iso?: string | null, lang: Lang = 'zh'): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(lang === 'zh' ? 'zh-CN' : 'en-US', { hour12: false });
}

/** 相对时间（如「刚刚 / 5分钟前」或 "just now / 5 min ago"），超过 30 天回退为绝对时间 */
export function relativeTime(iso?: string | null, lang: Lang = 'zh'): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const diff = Date.now() - d.getTime();
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return translate(lang, 'relTime.justNow');
  const min = Math.floor(sec / 60);
  if (min < 60) return translate(lang, 'relTime.minutes', { n: min });
  const hr = Math.floor(min / 60);
  if (hr < 24) return translate(lang, 'relTime.hours', { n: hr });
  const day = Math.floor(hr / 24);
  if (day < 30) return translate(lang, 'relTime.days', { n: day });
  return formatTime(iso, lang);
}

/** 将字节数格式化为人类可读的体积 */
export function formatBytes(bytes?: number): string {
  if (!bytes || bytes <= 0) return '—';
  const mb = bytes / 1024 / 1024;
  if (mb >= 1) return `${mb.toFixed(2)} MB`;
  return `${(bytes / 1024).toFixed(1)} KB`;
}

/** 根据应用名哈希到固定的渐变配色类，使卡片图标颜色稳定且多样 */
const GRADIENTS = ['grad-1', 'grad-2', 'grad-3'] as const;
export function iconGradientClass(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return GRADIENTS[Math.abs(hash) % GRADIENTS.length];
}

/** 取应用名首字符（大写）作为图标占位文字 */
export function firstChar(name: string): string {
  return name.trim().charAt(0).toUpperCase() || 'A';
}

/** 将进度数值约束到 0-100，非法值回退为 50 */
export function clampPct(n: number | undefined | null): number {
  if (typeof n !== 'number' || Number.isNaN(n)) return 50;
  return Math.max(0, Math.min(100, Math.round(n)));
}
